import _defaultApi from '@/utils/request';

const defaultApi = _defaultApi;

export default {
  /* -------------------- 首頁 Message -------------------- */
  GetMessageList() {
    return defaultApi({
      method: 'get',
      url: 'system/GetMessageList',
    });
  },
  GetChoiceMessageList() {
    return defaultApi({
      method: 'get',
      url: 'system/GetChoiceMessageList',
    });
  },

  /* -------------------- 彈出視窗 Message -------------------- */
  GetPopMessageList() {
    return defaultApi({
      method: 'get',
      url: 'system/GetPopMessageList',
    });
  },
  SetPersonalDataConsent(data) {
    return defaultApi({
      method: 'post',
      url: 'system/SetPersonalDataConsent',
      data,
    });
  },

  /* -------------------- 重設密碼 -------------------- */
  ResetPassword_ViewLoad() {
    return defaultApi({
      method: 'get',
      url: 'system/ResetPassword_ViewLoad',
    });
  },
  SetResetPassword(data) {
    return defaultApi({
      method: 'post',
      url: 'system/SetResetPassword',
      data,
    });
  },

  /* -------------------- ADMIN -------------------- */
  SyncRouterMapping(data) {
    return defaultApi({
      method: 'post',
      url: 'system/SyncRouterMapping',
      data,
    });
  },
  CleanRouterMapping(data) {
    return defaultApi({
      method: 'post',
      url: 'system/CleanRouterMapping',
      data,
    });
  },
  GetSystemInfo() {
    return defaultApi({
      method: 'get',
      url: 'system/GetSystemInfo',
    });
  },
  GetSessionList() {
    return defaultApi({
      method: 'get',
      url: 'system/GetSessionList',
    });
  },
  DeleteSessionData(data) {
    return defaultApi({
      method: 'post',
      url: 'system/DeleteSessionData',
      data,
    });
  },
};
